import { t } from '../i18n/index.js';
import { useSession } from '../lib/session.js';
import { Spinner } from '../ui/Spinner.js';
import { SignIn } from '../features/auth/SignIn.js';
import { Shell } from './Shell.js';

/**
 * The whole console, for now.
 *
 * Two states: signed out, or the console. Everything below `Shell` is routed
 * by `app/routes.ts` — forty lines over `popstate`, because four screens and
 * one nested parameter is not a router-shaped problem.
 *
 * ── WHY THE LOADING STATE IS NOT A BLANK SCREEN ───────────────────────────
 *
 * On load the console asks the platform who the stored token belongs to. Until
 * that answers it knows nothing — and rendering the sign-in screen meanwhile
 * would flash "sign in" at somebody who already is, on every reload.
 */
export function App() {
  const { me, loading } = useSession();

  if (loading) {
    return (
      <div className="cosmos-v2 flex min-h-screen items-center justify-center gap-3 bg-canvas text-secondary">
        <Spinner />
        <span className="text-md">{t('common.loading')}</span>
      </div>
    );
  }

  return me ? <Shell /> : <SignIn />;
}
